import React from "react";
import BeatLoader from "react-spinners/BeatLoader";

function Loader() {
  const inlineStyles = {
    mainLoaderContainer: {
      width: "100%",
      height: "100vh", 
      position: "absolute",
      left: 0,
      top: 0,
      zIndex: 15,
      display: "flex",
      flexDirection:'column',
      justifyContent: "center",
      alignItems: "center",
      gap:'10px'
    },
  };

  return (
    <div style={inlineStyles.mainLoaderContainer}>
      <BeatLoader color="#36d7b7" size={20} />
      <h3>Loading...</h3>
    </div>
  );
}

export default Loader;
